export const config = {
    apiServerBaseUrl: import.meta.env.VITE_API_SERVER_BASE_URL,
    isLocalDevelopmentEnvironment: import.meta.env.DEV,
};
